import AdminChangelogController from "./admin-changelog-controller";
import { connect } from "react-redux";
import { compose } from "redux";
import { withAuthRedirect } from "hoc/AuthRedirect";
import { getValue } from 'store/languages';
import { getChangeLogs, updateChangelog, setIsChangelogUpdated, createChangelog, deleteChangelog, getChangeLog, setChangeLog } from "store/change-log";
import { setRightMenuComponent, setShowRightMenu, setRemoveRightMenuComponent } from "store/side-bar";
 
let mapStateToProps = (state) => {
    return {
        role: state.Account.role,
        deviceType: state.header.deviceType,
        selectedLanguage: state.languages.selectedLanguage,
        changeLogs: state.ChangeLog.changeLogs,
        changeLog: state.ChangeLog.changeLog,
        selectedChangelogItem: state.ChangeLog.selectedChangelogItem,
        tableHeader: state.ChangeLog.tableHeader,
        controlButtons: state.ChangeLog.controlButtons,
        notificationsTypes: state.ChangeLog.notificationsTypes,
        isChangeLogUpdated: state.ChangeLog.isChangeLogUpdated,
        count: state.ChangeLog.totalElements,
        page: state.ChangeLog.page,
        showedItemsCount: state.paginator.showedItemsCount,
        currentPage: state.paginator.currentPage,
    }
}

const AdminChangelogContainer = compose(
    connect(mapStateToProps, {
        getValue,
        getChangeLogs,
        getChangeLog,
        setRightMenuComponent, 
        setShowRightMenu, 
        setRemoveRightMenuComponent,
        updateChangelog,
        setIsChangelogUpdated,
        createChangelog,
        deleteChangelog,
        setChangeLog
    }),
withAuthRedirect)(AdminChangelogController)

export default AdminChangelogContainer;